import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import ConfirmCodeEmailForm from "./components/AuthForms/ConfirmCodes/ConfirmCodeForgot/ConfirmCodeEmailForm";
import RegisterCodeForm from "./components/AuthForms/ConfirmCodes/RegisterCodeForm/RegisterCodeForm";
import ForgotPasswordForm from "./components/AuthForms/ForgotPasswordForm/ForgotPasswordForm";
import LoginForm from "./components/AuthForms/LoginForm/LoginForm";
import ResetPasswordForm from "./components/AuthForms/ResetPasswordForm/ResetPasswordForm";
import SignupCreatePassword from "./components/AuthForms/SignupCreatePassword/SignupCreatePassword";
import AuthLayout from "./components/AuthLayout/AuthLayout";
import MainLayout from "./components/MainLayout/MainLayout";
import BrandsPage from "./pages/BrandsPage/BrandsPage";
import BlogsPage from "./pages/BlogsPage/BlogsPage";
import CategoriesPage from "./pages/CategoriesPage/CategoriesPage";
import ClientsPage from "./pages/ClientsPage/ClientsPage";
import DiscountPage from "./pages/DiscountPage/DiscountPage";
import HistoryPage from "./pages/HistoryPage/HistoryPage";
import MainPage from "./pages/MainPage/MainPage";
import ManagementPage from "./pages/ManagementPage/ManagementPage";
import OrdersPage from "./pages/OrdersPage/OrdersPage";
import PhoneOrdersPage from "./pages/PhoneOrderPage/PhoneOrderPage";
import ProductsOrderPage from "./pages/ProductsOrderPage/ProductsOrderPage";
import ProductsPage from "./pages/ProductsPage/ProductsPage";
import ProductTypesPage from "./pages/ProductTypesPage/ProductTypesPage";
import TagsPage from "./pages/TagsPage/TagsPage";
import WarehousePage from "./pages/WarehousePage/WarehousePage";
import { useAuth } from "./providers/AuthProvider";
import { AuthPagesEnum } from "./types/authPages.type";

function App() {
  const auth = useAuth();

  useEffect(() => {
    auth.refreshAccessToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        {
          // auth.isAuthenticated
          auth.isAuthenticated ? (
            <Routes>
              <Route path={AuthPagesEnum.DEAFAULT} element={<MainLayout />}>
                {/* <Route index element={<Navigate to="/" />} /> */}
                <Route index element={<MainPage />} />
                <Route path={AuthPagesEnum.CLIENTS} element={<ClientsPage />} />

                <Route path={AuthPagesEnum.ORDERS} element={<OrdersPage />} />
                <Route
                  path={AuthPagesEnum.CRM_ORDERS}
                  element={<PhoneOrdersPage />}
                />

                <Route
                  path={AuthPagesEnum.WAREHOUSE}
                  element={<WarehousePage />}
                />
                <Route
                  path={AuthPagesEnum.PRODUCT}
                  element={<ProductsPage />}
                />
                <Route path={AuthPagesEnum.TAGS} element={<TagsPage />} />
                <Route
                  path={AuthPagesEnum.PRODUCT_TYPES}
                  element={<ProductTypesPage />}
                />
                <Route path={AuthPagesEnum.HISTORY} element={<HistoryPage />} />

                <Route
                  path={AuthPagesEnum.CATEGORIES}
                  element={<CategoriesPage />}
                />
                <Route path={AuthPagesEnum.BRANDS} element={<BrandsPage />} />
                <Route
                  path={AuthPagesEnum.PRODUCTS_ORDER}
                  element={<ProductsOrderPage />}
                />

                <Route
                  path={AuthPagesEnum.DISCOUNTS}
                  element={<DiscountPage />}
                />
                <Route path={AuthPagesEnum.BLOGS} element={<BlogsPage />} />
                <Route
                  path={AuthPagesEnum.MANAGEMENT}
                  element={<ManagementPage />}
                />

                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          ) : (
            <Routes>
              <Route path="/" element={<AuthLayout />}>
                <Route index element={<Navigate to="login" />} />
                <Route path="signupCode" element={<RegisterCodeForm />} />
                <Route
                  path="signupPassword"
                  element={<SignupCreatePassword />}
                />

                <Route path="login" element={<LoginForm />} />
                <Route path="forgotPassword" element={<ForgotPasswordForm />} />
                <Route path="confirmEmail" element={<ConfirmCodeEmailForm />} />
                <Route path="resetPassword" element={<ResetPasswordForm />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          )
        }
      </BrowserRouter>
    </div>
  );
}

export default App;
